import { ArrowForwardIcon, ArrowUpIcon, Button, Container, Flex, Image as UiKitImage, Link } from '@pancakeswap/uikit'
import styled from 'styled-components'
import { dackieColors } from 'utils/dackieConfigs'
import { useProtocolData } from 'views/Home/hooks/useProtocodata'
import { formatAmount } from 'utils/formatInfoNumbers'
import toNumber from 'lodash/toNumber'
import Image from 'next/image'
import useTheme from "hooks/useTheme";


const TextSpan = styled.div`
  color: ${({ theme }) => theme.colors.contrast};
`

const TextP = styled.p`
  color: ${({ theme }) => theme.colors.contrast};
`

const HomeContent = () => {
  const protocolData = useProtocolData()
  const { isDark, setTheme } = useTheme()

  return (
    <HomeContentWrapper>
      <ExtendContainer>
        <StatisticWrapper>
          <StatisticTop>
            <StatisticItem>
              <div className="value">{formatAmount(toNumber(protocolData?.totalVolumeUSD))}</div>
              <div className="title"><TextSpan>Trade Volume</TextSpan></div>
            </StatisticItem>
            <StatisticItem>
              <div className="value">{formatAmount(toNumber(protocolData?.totalValueLockedUSD))}</div>
              <div className="title"><TextSpan>Total Value Locked</TextSpan></div>
            </StatisticItem>
            {mockStatisticTop.map(({ title, value }, idx) => {
              return (
                // eslint-disable-next-line react/no-array-index-key
                <StatisticItem key={idx}>
                  <div className="value">{value}</div>
                  <div className="title"><TextSpan>{title}</TextSpan></div>
                </StatisticItem>
              )
            })}
          </StatisticTop>

          <StatisticBottom>
            <FlexBottom>
              <BgBigCard>
                <Link href="/info">
                  <span className="head-wrapper">
                    <span className="title head-title"> #1 Native DEX on</span>
                    <span className="head-title base-extend">
                      <BaseLogoExtend>
                        <Image src="/images/home/dackie/BASE_LOGO.png" alt="" width={32} height={32} quality="100" />
                        {/* <Image */}
                        {/*   src="/images/home/dackie/BASE_LOGO.svg" */}
                        {/*   alt="" */}
                        {/*   width={100} */}
                        {/*   height={100} */}
                        {/* /> */}
                        {/* <div className="bs-logo">
                          <NextImage
                            src="/images/home/dackie/BASE_LOGO.png"
                            alt=""
                            objectFit="contain"
                            layout="fill"
                            quality="100"
                          />
                        </div> */}

                        <span className="title head-title">BASE</span>
                        <ArrowUpIcon style={{ transform: 'rotate(45deg)', width: 30 }} color={isDark ? dackieColors.white : dackieColors.primary} />
                      </BaseLogoExtend>
                    </span>
                  </span>
                </Link>
                <TextP>
                  DackieSwap allows you to earn more rewards through Concentrated Liquidity Market Maker (CLMM).{' '}
                </TextP>
                <UiKitImage
                  className="img-responsive"
                  src="/images/home/dackie/DACKIE_HIDDEN.png"
                  width={380}
                  height={420}
                  style={{
                    position: 'absolute',
                    bottom: 0,
                    left: 0,
                    right: 0,
                    margin: '0 auto',
                  }}
                />
                <Link href="/liquidity">
                  <LaunchBtn>
                    <Flex
                      style={{
                        alignItems: 'center',
                        gap: 8,
                      }}
                    >
                      <span>Add Liquidity</span>
                      <ArrowForwardIcon color={dackieColors.black} />
                    </Flex>
                  </LaunchBtn>
                </Link>
              </BgBigCard>
              <FlexContain>
                {mockStatisticBottom.map(({ title, to, des }, idx) => {
                  return (
                    <LinkContainer href={to}>
                      {/* eslint-disable-next-line react/no-array-index-key */}
                      <BgCard key={idx}>
                        <Flex
                          style={{
                            alignItems: 'center',
                            marginBottom: 10,
                            gap: 12,
                          }}
                        >
                          <div className="title">{title}</div>
                          <ArrowUpIcon
                            color={isDark ? dackieColors.white : dackieColors.primary}
                            style={{
                              transform: 'rotate(45deg)',
                            }}
                          />
                        </Flex>
                      <div className="des">{des}</div>
                    </BgCard>
                  </LinkContainer>
                  )
                })}
              </FlexContain>
            </FlexBottom>
          </StatisticBottom>
        </StatisticWrapper>
      </ExtendContainer>
    </HomeContentWrapper>
  )
}

export default HomeContent

const LinkContainer = styled(Link)`
  width: auto;
`

const LaunchBtn = styled(Button)`
  height: 40px;
  color: ${dackieColors.black};
  background-color: ${dackieColors.launchBtn};
  box-shadow: ${dackieColors.btnShadow};

  /* Position the button at the bottom */
  position: absolute;
  bottom: 15px;
  //left: 50%; /* Optionally, you can horizontally center the button */
  //transform: translateX(-50%); /* Optionally, you can horizontally center the button */
`

const BaseLogoExtend = styled(Flex)`
  gap: 10px;
  align-items: flex-end;
  .bs-logo {
    width: 35px;
    height: 35px;
    overflow: hidden;
    position: relative;
  }
  .title {
    position: relative;
    top: 12px;
  }
  @media screen and (max-width: 515px) {
    align-items: flex-end;
    gap: 8px;

    .title {
      top: 5px;
    }
    .bs-logo {
      width: 28px;
      height: 28px;
    }
  }
`

const ExtendContainer = styled(Container)`
  @media screen and (max-width: 515px) {
    padding: 15px;
  }
`

const BgCardContainer = styled.div`
  width: 100%;
`

const BgCard = styled.div`
  background: ${({ theme }) => theme.isDark ? dackieColors.hardBlue : dackieColors.white};
  box-shadow: ${dackieColors.cardShadow};
  border-radius: 16px;
  padding: 24px;
  overflow: hidden;
  position: relative;
  transition: all 0.3s ease;
  cursor: pointer;
  width: 100%;
  .title {
    font-size: 24px;
    font-weight: 700;
    color: ${({ theme }) => theme.colors.text};
  }
  .des {
    font-size: 18px;
    font-weight: 500;
    color: ${({ theme }) => theme.colors.contrast};
  }
  .head-title {
    font-size: 36px;
    display: inline-block;
  }
  .base-extend {
    position: relative;
    bottom: -3px;
    left: 10px;
  }
  &:hover {
    box-shadow: ${({ theme }) => theme.isDark ? `0px 0px 10px 0px rgba(255,255,255,0.10)` : `0px 0px 20px 0px rgba(0,102,255,0.50)`};
  }
  @media screen and (max-width: 515px) {
    padding: 15px;
    .head-title {
      font-size: 23px;
    }
  }
`

const BgBigCard = styled(BgCard)`
  width: 50%;
  p {
    position: relative;
    z-index: 2;
  }

  @media screen and (max-width: 515px) {
    /* padding: 15px; */
    width: 100%;
    height: 345px;
    .head-wrapper {
      white-space: nowrap;
    }
    .img-responsive {
      max-height: 375px !important;
      max-width: 350px !important;
    }
  }
`

const FlexContain = styled(Flex)`
  flex-direction: column;
  gap: 20px;
  align-items: stretch;
  justify-content: stretch;
  flex: 1;
  flex-wrap: wrap;
  a {
    color: inherit;
    &:hover {
      text-decoration: none;
    }
  }
`
const FlexBottom = styled(Flex)`
  width: 100%;
  gap: 20px;
  flex-wrap: wrap;
  h1 {
    font-size: 36px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }
  p {
    margin-top: 15px;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }
`

const StatisticItem = styled.div`
  position: relative;
  padding: 45px 75px;
  text-align: center;
  flex: 1;
  .value {
    text-align: center;
    font-size: 48px;
    font-style: normal;
    font-weight: 700;
    line-height: 72px;
    color: ${({ theme }) => theme.colors.text};
  }
  .title {
    color: ${dackieColors.black};
  }

  &:not(:last-child) {
    &::after {
      content: '';
      position: absolute;
      height: 25%;
      width: 1px;
      background-color: ${({ theme }) => theme.colors.text};
      right: -30px;
      top: 0;
      bottom: 0;
      margin: auto 0;
    }
  }

  @media screen and (max-width: 515px) {
    padding: 10px;
    &:not(:last-child) {
      &::after {
        right: -15px;
        height: 40%;
      }
    }
    .value {
      font-size: 38px;
    }
  }
`

const StatisticWrapper = styled.div`
  display: flex;
  justify-content: stretch;
  flex-direction: column;
  gap: 45px;
`
const StatisticBottom = styled.div`
  width: 100%;
`
const StatisticTop = styled(Flex)`
  border-radius: 24px;
  justify-content: center;
  align-items: center;
  gap: 60px;
  width: 100%;
  flex-wrap: wrap;
  @media screen and (max-width: 515px) {
    gap: 20px;
  }
`

const HomeContentWrapper = styled.div`
  background: ${({ theme }) => (theme.isDark ? '#101530' : '#f1f5ff')};
  /* height: calc(100vh); */
  width: 100%;
  padding: 175px 0 100px 0;
  color: ${dackieColors.black};
  position: relative;
  z-index: 100;
  top: -1px;
  @media screen and (max-width: 425px) {
    padding: 75px 0;
    height: auto;
  }
`

const mockStatisticTop = [
  // {
  //   title: "Trade Volume",
  //   value: "$489B+",
  // },
  // {
  //   title: "Total value locked",
  //   value: "71M+",
  // },
  {
    title: 'Dackie Community',
    value: '100K+',
  },
]

const mockStatisticBottom = [
  {
    title: 'Swap',
    to: '/swap',
    des: 'Swap any token on BASE in seconds, just by connecting your wallet.',
  },
  {
    title: 'DackiePad',
    to: '/#',
    des: 'Purchase the most potential gems on BASE.',
  },
  {
    title: 'NFT Pools',
    to: '/nft-pools',
    des: 'Stake your NFTs to earn exclusive rewards.',
  },
]
